// テキスト入力テンプレート定義
export type TemplateType = "none" | "repeat_elements";

export interface TextTemplate {
  id: TemplateType;
  label: string;
  content: string;
}

// テンプレート内容の定義
export const TEXT_TEMPLATES: Record<TemplateType, string> = {
  none: "",
  repeat_elements: `# 依頼内容
htmlから繰り返し要素を判定して、ターゲットを生成してください。

# htmlの内容
ここにhtmlを張り付けてください`,
};

// テンプレート選択肢の定義
export const TEMPLATE_OPTIONS: TextTemplate[] = [
  { id: "none", label: "テンプレートを使用しない", content: TEXT_TEMPLATES.none },
  {
    id: "repeat_elements",
    label: "繰り返し要素を抽出",
    content: TEXT_TEMPLATES.repeat_elements,
  },
];

